import actions from "./actions"
import getters from "./getters"
import mutations from "./mutations"
import { CollegeTeamHighlight } from "@/models"

const state = {
  collegeTeamHighlight: new CollegeTeamHighlight(),
  collegeTeamHighlights: [],
  collegeTeamHighlightLoading: false,
  collegeTeamHighlightsLoading: false,
  collegeTeamHighlightsLimited: [],
  meta: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
